import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function OperatorTenantDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"OperatorTenant Details"}
                            editHref={"/operator-tenant/update"}
                            endpoint={"operator-tenant/read"}
                            relations={["operator", "tenant"]}
                        />
}

export default OperatorTenantDetailsPage;